export default class Country {
    static fromData(data) {
        if (!data) {
            return;
        }

        let country = new Country();
        country.code = data.code;
        country.name = data.name;

        Object.seal(country);
        return country;
    }
}
